import { Category } from '../../api';

export type CategoryShape = {
  categories: Category[];
  selectedId: Category['id'];
  expandedKeys: Category['id'][];
  loading: boolean;
};

export const ALL_CATEGORIES_ID: Category['id'] = '0';
export const ALL_CATEGORIES_NAME = 'All categories';
